<ion-content class="ion-padding custom-modal">
  <form [formGroup]="activationForm">
    <swiper-container #swiper >
      <swiper-slide>
        <ion-icon name="close-circle" size="large" class="close-button" (click)="dismiss()"></ion-icon>
        <video autoplay playsinline muted loop class="custom-video" #videoEl>
          <source src="../../assets/images/activation-animation.mp4" type="video/mp4" />
        </video>
        <ion-button
          size="medium"
          shape="round"
          expand="full"
          (click)="slideNavigation()">{{ 'COMMON.start' | translate }}</ion-button>
      </swiper-slide>
      <!-- NAME -->
      <swiper-slide>
        <ion-text class="input-padding">
          <h4>{{'ACTIVATION.letsBegin' | translate}}</h4>
        </ion-text>
        <ion-text class="input-padding">
          <span>{{'ACTIVATION.insertName' | translate}}</span>
        </ion-text>
        <sol-input
          formControlName="name"
          [editMode]="true"
          [showIcon]="false"
          [showOutline]="true"
          label="Nome">
        </sol-input>
        <ion-button
          size="medium"
          shape="round"
          expand="full"
          [disabled]="activationForm.get('name')?.invalid"
          (click)="slideNavigation()">{{ 'COMMON.next' | translate }}
        </ion-button>
        <ion-button
          size="medium"
          shape="round"
          expand="full"
          fill="outline"
          (click)="slideNavigation(false)">{{'COMMON.previous' | translate}}
        </ion-button>
      </swiper-slide>
      <!-- EMAIL -->
      <swiper-slide>
        <ion-text class="input-padding">
          <h4>{{'ACTIVATION.insertEmail' | translate}}</h4>
          <span>{{'ACTIVATION.enterYourEmail' | translate}}</span>
        </ion-text>
        <sol-input
          formControlName="email"
          [editMode]="true"
          [showIcon]="false"
          label="Email"></sol-input>
        <ion-button
          size="medium"
          shape="round"
          expand="full"
          [disabled]="activationForm.get('email')?.invalid"
          (click)="slideNavigation()">{{ 'COMMON.next' | translate }}
        </ion-button>
        <ion-button
          size="medium"
          shape="round"
          expand="full"
          fill="outline"
          (click)="slideNavigation(false)">{{'COMMON.previous' | translate}}
        </ion-button>
      </swiper-slide>
      <!-- EMAIL CONFIRMATION -->
      <swiper-slide>
        <ion-text class="input-padding">
          <h4>{{'ACTIVATION.emailConfirmationTitle' | translate}}</h4>
          <span>{{'ACTIVATION.emailConfirmation' | translate}}</span>
        </ion-text>
        <sol-input
          formControlName="confirmEmail"
          [editMode]="true"
          [showIcon]="false"
          [label]="'ACTIVATION.emailRepeat' | translate">
        </sol-input>
        <ion-button
          size="medium"
          shape="round"
          expand="full"
          [disabled]="(activationForm.get('email')?.invalid && activationForm.get('confirmEmail')?.invalid) ||
              activationForm.get('email')?.value !== activationForm.get('confirmEmail')?.value"
          (click)="slideNavigation()">{{ 'COMMON.next' | translate }}
        </ion-button>
        <ion-button
          size="medium"
          shape="round"
          expand="full"
          fill="outline"
          (click)="slideNavigation(false)">{{'COMMON.previous' | translate}}
        </ion-button>
      </swiper-slide>
      <!-- PIN -->
      <swiper-slide>
        <ion-text class="input-padding">
          <h4>{{'ACTIVATION.pinHeader' | translate}}</h4>
        </ion-text>
        <ion-text class="input-padding">
          <span>{{'ACTIVATION.pinFind' | translate}}</span>
        </ion-text>
        <sol-input
          formControlName="pin"
          [editMode]="true"
          [showIcon]="false"
          label="PIN"
          [helperText]="isPinValid === false ? ('ACTIVATION.pinError' | translate) : ''">
        </sol-input>
          <ion-button
            size="medium"
            shape="round"
            expand="full"
            [disabled]="activationForm.get('pin')?.invalid"
            (click)="slideNavigation()">{{ 'COMMON.next' | translate }}
          </ion-button>
          <ion-button
            size="medium"
            shape="round"
            expand="full"
            fill="outline"
            (click)="slideNavigation(false)">{{'COMMON.previous' | translate}}
          </ion-button>
      </swiper-slide>
      <!-- PASSWORD -->
      <swiper-slide>
        <ion-text class="input-padding">
          <h4>{{'ACTIVATION.passwordHeader' | translate}}</h4>
        </ion-text>
        <ion-text class="input-padding">
          <span>{{'ACTIVATION.passwordDescription' | translate}}</span>
        </ion-text>
        <sol-input
          formControlName="password"
          [editMode]="true"
          [showIcon]="false"
          [inputType]="TYPE_OF_INPUT.PASS"
          label="Password">
        </sol-input>
        <ion-button
            size="medium"
            shape="round"
            expand="full"
            [disabled]="activationForm.get('password')?.invalid"
            (click)="slideNavigation()">{{ 'COMMON.next' | translate }}
        </ion-button>
        <ion-button
          size="medium"
          shape="round"
          expand="full"
          fill="outline"
          (click)="slideNavigation(false)">{{'COMMON.previous' | translate}}
        </ion-button>
      </swiper-slide>
      <!-- PASSWORD CONFIRMATION -->
      <swiper-slide>
        <ion-text class="input-padding">
          <h4>{{'ACTIVATION.passwordHeader' | translate}}</h4>
        </ion-text>
        <ion-text class="input-padding">
          <span>{{'ACTIVATION.passwordDescription' | translate}}</span>
        </ion-text>
        <sol-input
          formControlName="confirmPassword"
          [editMode]="true"
          [inputType]="TYPE_OF_INPUT.PASS"
          [showIcon]="false"
          [label]="'ACTIVATION.passwordRepeat' | translate">
        </sol-input>
        @if (!activating) {
          <ion-button
            size="medium"
            shape="round"
            expand="full"
            [disabled]="activationForm.get('confirmPassword')?.invalid ||
              activationForm.get('password')?.value !== activationForm.get('confirmPassword')?.value"
            (click)="slideNavigation(true, true)">{{'COMMON.activate' | translate}}
          </ion-button>
        } @else {
          <ion-button
            size="medium"
            shape="round"
            expand="full"
            disabled
            (click)="slideNavigation(true, true)">{{'ACTIVATION.activating' | translate}}
            <ion-icon src="../../assets/images/loading.svg"></ion-icon>
          </ion-button>
        }
        <ion-button
          size="medium"
          shape="round"
          expand="full"
          fill="outline"
          (click)="slideNavigation(false)">{{'COMMON.previous' | translate}}
        </ion-button>
      </swiper-slide>
      <!-- CARTAO ATIVADO -->
      <swiper-slide>
        <ion-icon name="close-circle" size="large" class="close-button" (click)="dismiss()"></ion-icon>
        <div class="ok-content">
          <ng-lottie
            [options]="animationOptions"
            (animationCreated)="animationCreated($event)" />
          <ion-text>
            <span>{{'ACTIVATION.solloActivated' | translate}}</span>
          </ion-text>
        </div>
      </swiper-slide>

    </swiper-container>
  </form>
</ion-content>
